export default __webpack_public_path__ + "static/media/bannerbottom.6ef962f5.svg";